import { activities } from "./activities/activities";
import { attributes } from "./attributes/attributes";
import { categories } from "./categories/categories";
import { cities } from "./cities/cities";
import { communities } from "./communities/communities";
import { draws } from "./draws/draws";
import { floors } from "./floors/floors";
import { homes } from "./homes/homes";
import { materials } from "./materials/materials";
import { plans } from "./plans/plans";
import { pricing } from "./pricing/pricing";
import { requirements } from "./requirements/requirements";
import { series } from "./series/series";
import { accountConfigs } from "./accountConfigs/accountConfigs";
import { accountDrops } from "./accountDrops/accountDrops";
import { accountPricing } from "./accountPricing/accountPricing";
import { areaTypes } from "./areaTypes/areaTypes";
import { bidLineItems } from "./bidLineItem/bidLineItem";
import { bidRequests } from "./bidRequests/bidRequests";
import { communityInspectionAuthorities } from "./communityInspectionAuthorities/communityInspectionAuthorities";
import { communityVendors } from "./communityVendors/communityVendors";
import { dropPriceLevel } from "./dropPriceLevel/dropPriceLevel";
import { dropPrices } from "./dropPrices/dropPrices";
import { dropTypes } from "./dropTypes/dropTypes";
import { inspectionAuthorities } from "./inspectionAuthorities/inspectionAuthorities";
import { priceLevel } from "./priceLevel/priceLevel";
import { seriesGroup } from "./seriesGroup/seriesGroup";

export const homeService = {
  homes,
  communities,
  communityVendors,
  communityInspectionAuthorities,
  plans,
  areaTypes,
  bidLineItems,
  bidRequests,
  cities,
  activities,
  attributes,
  categories,
  materials,
  pricing,
  accountConfigs,
  accountPricing,
  accountDrops,
  dropTypes,
  floors,
  series,
  seriesGroup,
  draws,
  dropPrices,
  priceLevel,
  dropPriceLevel,
  inspectionAuthorities,
  requirements,
};
